module.exports = __webpack_public_path__ + "img/bp-yellow.18fbcb6d.png";